import { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import './com-number.less'

/*
* props参数
* className: 自定义class名称
* number: 传递的数值 [Number, String]
* isComma: 是否隔三位数加一个逗号
*/

const ComNumber = (props) => {
  const [state, setState] = useState({
    numList: []
  })

  useEffect(() => {
    getNumData();
  }, [props])

  const getNumData = () => {
    let { number, isComma } = props, _str = number || number=='0' ? number : '';
    if (typeof number == 'number') _str += '';
    if (!_str.length) return;

    let _spt = _str.split('') || [];
    if (isComma) _spt = addComma(_spt);

    let numList = _spt.map(item => {
      let obj = { num: item, parclass:'', iconclass: '', isPoint: false, isComma: false, isGang: false, isEmpty: false };
      obj.parclass = `num-${item}`;
      obj.iconclass = `icon-num-${item}`;

      if (item.includes('.') || item.includes('。')){
        obj.isPoint = true;
        obj.parclass = `num-dot`;
        obj.iconclass = `icon-num-dot`;
      }
      if (item.includes(',') || item.includes('，')){
        obj.isComma = true;
        obj.parclass = `num-comma`;
        obj.iconclass = `icon-num-comma`;
      }
      if (item.includes('-') || item.includes('——') || item.includes('_')){
        obj.isGang = true;
        obj.parclass = `num-gang`;
        obj.iconclass = `icon-num-gang`;
      }
      if (!item || item.includes(' ')){
        obj.isEmpty = true;
        obj.parclass = `num-empty`;
        obj.iconclass = ``;
      }
      return obj;
    })
    setState({ numList });
  }
  const addComma = (list=[], newList=[]) => {    //超过3位加逗号
    let _idx = list.indexOf('.');
    if (_idx!=-1 && list[_idx+1]) newList = newList.concat(list.splice(_idx));   //小数点先取出来存到新数组最后

    if (list.length > 3){
      newList.unshift(',', ...(list.splice(list.length-3)));
      addComma(list, newList);
    }else {
      newList.unshift(...list);
    }
    return newList;
  }

  return (
    <div className={`com-number-wrap ${props.className||''}`}>
      <ul className='num-lit lflex'>
        {state.numList.map((item, index) => 
          <li className={`num-item cflex ${item.parclass}`} key={index}>
            <span className={`num-icon iconfont ${item.iconclass}`}></span>
          </li>
        )}
      </ul>
    </div>
  )
}

export default withRouter(ComNumber);